import { createSlice } from '@reduxjs/toolkit'

/**
 * Redux slice holding the toast notification queue.
 */
export const notificationsSlice = createSlice({
  name: 'notification',

  initialState: {
    items: []
  },

  reducers: {
    addNotifications: (state, action) => {
      state.item = action.payload
    }
  }
})

/**
 * Replaces the notification queue with the given notifications.
 */
export const { addNotifications } = notificationsSlice.actions

/**
 * Selects the current notification queue.
 *
 * @param {Object} state - Redux state.
 * @returns {Array} Queued notifications.
 */
export const notifications = state => state.notifications.item
